import { Action } from '@ngrx/store';

import { SchoolSearchResultsItem, SchoolSearchCriteria, SchoolPagingSorting } from '../../../scp/schools/models';
import { HttpHeaders } from '@angular/common/http';

export enum ReportsSchoolSearchResultsActionTypes {
  ProcessReportQueryString = '[SchoolReportSearchResults] Process Query String',
  LoadReportSchoolSearchResults = '[SchoolReportSearchResults] Load Search Results',
  LoadReportSchoolSearchResultsSuccess = '[SchoolReportSearchResults] Load School Success',
  LoadReportSchoolSearchResultsFailure = '[SchoolReportSearchResults] Load School Details Failure',
  UpdateEditorState = '[SchoolReportSearchResults] Update Editor State',
  UpdateSchoolInfo = '[SchoolReportSearchResults] Update School Info',
  UpdateSchoolInfoSuccess = '[SchoolReportSearchResults] Update School Info Success',
  UpdateSchoolInfoFailure = '[SchoolReportSearchResults] Update School Info Failure',
  NextPage = '[SchoolReportSearchResults] Next Page',
  PrevPage = '[SchoolReportSearchResults] Prev Page',
  SetPageSize = '[SchoolReportSearchResults] Set Page Size',
  LastPage = '[SchoolReportSearchResults] Last Page',
  FirstPage = '[SchoolReportSearchResults] First Page',
  SortBy = '[SchoolReportSearchResults] Sort By',
}

export class ProcessReportQueryString implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.ProcessReportQueryString;
  constructor(public payload: string) { }
}

export class LoadReportSchoolSearchResults implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.LoadReportSchoolSearchResults;
  constructor(public payload: SchoolSearchCriteria) { }
}

export class LoadReportSchoolSearchResultsSuccess implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.LoadReportSchoolSearchResultsSuccess;
  constructor(public payload: SchoolSearchResultsItem[], public httpHeaders: HttpHeaders) { }
}

export class LoadReportSchoolSearchResultsFailure implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.LoadReportSchoolSearchResultsFailure;
  constructor(public payload: any) { }
}

export class NextPage implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.NextPage;
  constructor(public payload: SchoolSearchCriteria, public pagingSorting: SchoolPagingSorting) { }
}

export class PrevPage implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.PrevPage;
  constructor(public payload: SchoolSearchCriteria, public pagingSorting: SchoolPagingSorting) { }
}

export class SetPageSize implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.SetPageSize;
  constructor(public payload: number, public searchCriteria: SchoolSearchCriteria,) { }
}

export class LastPage implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.LastPage;
  constructor(public payload: SchoolSearchCriteria, public pagingSorting: SchoolPagingSorting) { }
}

export class FirstPage implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.FirstPage;
  constructor(public payload: SchoolSearchCriteria, public pagingSorting: SchoolPagingSorting) { }
}

export class SortBy implements Action {
  readonly type = ReportsSchoolSearchResultsActionTypes.SortBy;
  constructor(public payload: string, public searchCriteria: SchoolSearchCriteria, public pagingSorting: SchoolPagingSorting) { }
}

export type ReportsSchoolSearchResultsActions =
  | ProcessReportQueryString
  | LoadReportSchoolSearchResults
  | LoadReportSchoolSearchResultsSuccess
  | LoadReportSchoolSearchResultsFailure
  | NextPage
  | PrevPage
  | SetPageSize
  | LastPage
  | FirstPage
  | SortBy;
